export const FETCH_LOCATION_START = "FETCH_LOCATION_START";
export const FETCH_LOCATION_SUCCESS = "FETCH_LOCATION_SUCCESS";
export const FETCH_LOCATION_FAIL = "FETCH_LOCATION_FAIL";
